import React, { Fragment, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  useClassroomDoughnuts,
  MOUSE_STATE_LEAVE,
  doughnutWidth,
  doughnutGap,
  STUDENT
} from './doughnuts-inner-hooks';
import ContextModal from '../context-modal';
import { ContextModalContent } from './styled';

const DoughnutsInner = ({ i18n, classroomPct, groupPct, studentPct, resultType, noQuestions }) => {
  const [AllDoughnuts, { doughnutType, mouseState }] = useClassroomDoughnuts({
    resultType, classroomPct, groupPct, studentPct
  });
  const svgRef = useRef(null);
  const modalWidth = 220;
  const classContextPos = 160;
  const contextOffset = doughnutWidth + (resultType === STUDENT ? (doughnutGap / 2) : doughnutGap);
  const contextModalYPos = classContextPos - (doughnutType * contextOffset);
  const percentages = [classroomPct, groupPct, studentPct];
  const [positionX, setPostionX] = useState(0);

  let contextMessage = `${percentages[doughnutType]}% ${i18n.t`correct responses on average`}`;
  if (percentages[doughnutType] === 0 && noQuestions) {
    contextMessage = i18n.t`No data. Complete assessments and try again.`;
  }

  useEffect(() => {
    setPostionX((svgRef.current.parentNode.clientWidth - modalWidth) / 2);
  }, [doughnutType]);

  return (
    <Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        height="160"
        width="160"
        className="doughnut-svg"
        ref={svgRef}
      >
        <AllDoughnuts />
      </svg>
      <ContextModal
        show={mouseState !== MOUSE_STATE_LEAVE}
        positionArrow={modalWidth / 2}
        positionX={positionX}
        positionY={contextModalYPos}
        fixedParent
        contextTheme="standard"
        name={<ContextModalContent>{contextMessage}</ContextModalContent>}
        modalWidth={modalWidth}
      />
    </Fragment>
  );
};

DoughnutsInner.propTypes = {
  i18n: PropTypes.object,
  classroomPct: PropTypes.number,
  groupPct: PropTypes.number,
  studentPct: PropTypes.number,
  resultType: PropTypes.number,
  noQuestions: PropTypes.bool
};

export default DoughnutsInner;
